import { BaseModel, fillOwnProperties, registerModel } from '~/shared/model'
import { isUnknownObject } from '~/shared/utils/guards'

export default class DigitalLectureTag extends BaseModel {
  static override constructorName = 'DigitalLectureTag'

  id: number = 0
  name: string = ''
  sort: number = 0

  constructor(data?: unknown) {
    super(data)
    if (isUnknownObject(data)) {
      fillOwnProperties(this, data)
    }
  }
}

registerModel(DigitalLectureTag)
